import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { youngerThan18 } from '../../../helpers';
import WidgetPropTypes from '../types';
import WidgetPagePropTypes from '../../WidgetPage/types';
import Cleave from '../../../components/UI/CustomInputField/CustomCleaveField';

export const WIDGET_NAME = 'set_user_date_of_birth';
export const DOB_FORMAT_ERROR_MESSAGE =
  'Your date of birth should be in the format MM/DD/YYYY';
export const YOUNGER_THAN_18_ERROR_MESSAGE =
  'You must be 18 years or older to register as a parent for Greenlight.';

class DateOfBirth extends Component {
  constructor() {
    super();

    this.state = {
      dob: '',
      error: false,
      errorMessage: ''
    };
  }

  componentDidMount() {
    this.props.analytics.trackEvent('Registration DOB Viewed', {
      eventProps: {
        role: get(this.props, 'app.answers.setRole')
      }
    });

    if (get(this.props, 'app.prefilledAnswers.setUserDateOfBirth')) {
      this.setState({
        dob: this.props.app.prefilledAnswers.setUserDateOfBirth
      });
    }
  }

  errorChecking = async () => {
    if (this.state.dob.length !== 10) {
      this.setState({
        error: true
      });
      this.props.createError({
        message: DOB_FORMAT_ERROR_MESSAGE,
        registrationStep: WIDGET_NAME
      });
      throw new Error();
    }
    if (
      get(this.props, 'app.answers.setRole') === 'parent' ||
      get(this.props, 'app.answers.setRole') === 'approver'
    ) {
      if (youngerThan18(this.state.dob)) {
        this.setState({
          error: true
        });
        this.props.createError({
          message: YOUNGER_THAN_18_ERROR_MESSAGE,
          registrationStep: WIDGET_NAME
        });
        throw new Error();
      }
    }
    this.setState({ error: false, errorMessage: '' });
    return false;
  };

  render() {
    const { changeAnswerValue, shouldEnable, widget } = this.props;
    return (
      <div>
        <Cleave
          id="dateOfBirthId"
          placeholder="Your date of birth"
          options={{
            date: true,
            datePattern: ['m', 'd', 'Y']
          }}
          error={this.state.error}
          rawValue={false}
          value={this.state.dob}
          format={this.state.errorMessage || 'MM/DD/YYYY'}
          inputMode="numeric"
          className="fs-mask"
          onClick={this.props.onClick}
          onChange={value => {
            this.setState({ dob: value });
            shouldEnable(widget, value.length > 7);
            changeAnswerValue(widget, value);
          }}
          data-e2e="date-of-birth"
        />
      </div>
    );
  }
}

DateOfBirth.propTypes = {
  changeAnswerValue: WidgetPropTypes.changeAnswerValue.isRequired,
  index: WidgetPropTypes.index.isRequired,
  onClick: WidgetPropTypes.onClick.isRequired,
  shouldEnable: WidgetPropTypes.shouldEnable.isRequired,
  widget: WidgetPropTypes.widget.isRequired,
  app: WidgetPagePropTypes.app,
  analytics: WidgetPagePropTypes.analytics
};

export default DateOfBirth;
